export default __webpack_public_path__ + "static/media/IMG-2732.6404ed67.jpg";